import http from "./http";

//管理员登录（不需要验证码）
export const login = async (data) => {
    return await http.post(`/admin/login`, data);
};
//管理员登录（需要验证码）
export const loginPro = async (data) => {
    return await http.post(`/admin/loginPro`, data);
};
//校对验证码
export const verifyCode = async (data) => {
    return await http.post(`/kaptcha/verifyCode`, data);
};
//管理员登出
export const logout = async (data) => {
    return await http.post(`/admin/ctrl/logout`, data);
};
